import backgroundColor from './scriptableOptions/backgroundColor.js';
import borderColor from './scriptableOptions/borderColor.js';

export default function scriptableOptions() {
    return {
        backgroundColor,
        //borderColor,
    };
}
